import { useCallback, useEffect, useState } from 'react';
import moment from 'moment';
import api from '../services/api';

export const useReferenceData = () => {
  const [resources, setResources] = useState([]);
  const [discountCodes, setDiscountCodes] = useState([]);

  useEffect(() => {
    let mounted = true;

    const loadResources = async () => {
      try {
        const res = await api.get('/resources/');
        if (mounted) {
          setResources(res.data.map(item => ({
            id: item.id,
            title: item.name,
            resource_type: item.resource_type,
            sort: item.sort,
          })));
        }
      } catch (error) {
        console.error('Failed to load simulators:', error);
      }
    };

    const loadDiscountCodes = async () => {
      try {
        const res = await api.get('/discount-codes/');
        if (mounted) {
          setDiscountCodes(res.data.map(item => ({
            id: item.id,
            code: item.code,
            description: item.description,
          })));
        }
      } catch (error) {
        console.error('Failed to load discount codes:', error);
      }
    };

    loadResources();
    loadDiscountCodes();

    return () => {
      mounted = false;
    };
  }, []);

  return { resources, discountCodes };
};

export const useDailyEvents = (selectedDate, { activeOnly = false, refreshToken } = {}) => {
  const [events, setEvents] = useState([]);

  const loadEvents = useCallback(async () => {
    if (!selectedDate) return;

    const formattedDate = moment(selectedDate).format('YYYY-MM-DD');
    const query = activeOnly ? '?active=true' : '';

    try {
      const res = await api.get(`/daily-events/${formattedDate}/${query}`);
      setEvents(res.data);
    } catch (error) {
      console.error('Failed to load events:', error);
    }
  }, [selectedDate, activeOnly]);

  useEffect(() => {
    loadEvents();
  }, [loadEvents, refreshToken]);

  return { events, reload: loadEvents };
};

export const useDailyHolds = (selectedDate, { activeOnly = false, resourceType, refreshToken } = {}) => {
  const [holds, setHolds] = useState([]);

  const loadHolds = useCallback(async () => {
    if (!selectedDate) return;

    const formattedDate = moment(selectedDate).format('YYYY-MM-DD');
    const params = new URLSearchParams();
    if (activeOnly) {
      params.set('active', 'true');
    }
    if (resourceType) {
      params.set('resource_type', String(resourceType));
    }
    const query = params.toString() ? `?${params.toString()}` : '';

    try {
      const res = await api.get(`/daily-holds/${formattedDate}/${query}`);
      setHolds(res.data);
    } catch (error) {
      console.error('Failed to load holds:', error);
    }
  }, [selectedDate, activeOnly, resourceType]);

  useEffect(() => {
    loadHolds();
  }, [loadHolds, refreshToken]);

  return { holds, reload: loadHolds };
};

export const useCheckInStates = () => {
  const [states, setStates] = useState([]);

  useEffect(() => {
    let mounted = true;

    const loadStates = async () => {
      try {
        const res = await api.get('/check-in-state/');
        if (mounted) {
          setStates(res.data);
        }
      } catch (error) {
        console.error('Failed to load check-in states:', error);
      }
    };

    loadStates();

    return () => {
      mounted = false;
    };
  }, []);

  return states;
};
